import { employeeConstants } from "../../constants";
export function addEmployeeReducer(state = {}, action) {
  switch (action.type) {
    case employeeConstants.POST_EMPLOYEE_REQUEST:
      return { loading: true };
    case employeeConstants.POST_EMPLOYEE_SUCCESS:
      return { employee: action.payload.data };
    case employeeConstants.POST_EMPLOYEE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
